import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { CountBox as d } from "../Countbox/index.js";
import { Ratings as _ } from "../Ratings/index.js";
import { SimplyReviewLogo as m } from "../Logos/SimplyReview.js";
import { getRatingLabel as y } from "../../utils/rating.js";
import '../../assets/index5.css';const p = "_testClass_slxya_1", x = "_card_slxya_16", h = "_avatar_slxya_25", g = "_name_slxya_32", f = "_title_slxya_43", u = "_description_slxya_56", v = "_date_slxya_68", w = "_headlineWrapper_slxya_80", C = "_headline_slxya_80", N = "_text_slxya_99", I = "_row_slxya_112", a = {
  testClass: p,
  card: x,
  avatar: h,
  name: g,
  title: f,
  description: u,
  date: v,
  headlineWrapper: w,
  headline: C,
  text: N,
  row: I
};
var L = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.center = "center", e))(L || {});
function R(e) {
  switch (e) {
    case "left":
      return { alignItems: "flex-start" };
    case "right":
      return { alignItems: "flex-end" };
    case "center":
      return { alignItems: "center" };
    default:
      return { alignItems: "center" };
  }
}
function H({
  alignment: e = "center",
  reviewCount: n,
  rating: l,
  slug: o,
  textColor: i
}) {
  const c = R(e), s = i || "#212b36";
  return /* @__PURE__ */ r("div", { className: a.headlineWrapper, style: c, children: [
    /* @__PURE__ */ r("div", { className: a.row, children: [
      /* @__PURE__ */ t(d, { rating: l, backgroundColor: s }),
      /* @__PURE__ */ t("div", { style: { paddingRight: 8 } }),
      /* @__PURE__ */ t("div", { className: a.headline, style: { color: s }, children: y(l) }),
      /* @__PURE__ */ t("div", { style: { marginLeft: 8 } }),
      /* @__PURE__ */ t(_, { rating: l })
    ] }),
    /* @__PURE__ */ r("div", { className: a.row, style: { opacity: 0.5 }, children: [
      /* @__PURE__ */ r("p", { className: a.text, style: { color: s }, children: [
        n,
        " reviews on",
        " "
      ] }),
      /* @__PURE__ */ t("div", { style: { marginLeft: 8 } }),
      /* @__PURE__ */ t(
        m,
        {
          style: { width: 58, marginBottom: -4 },
          slug: o,
          color: s
        }
      )
    ] })
  ] });
}
export {
  L as Alignment,
  H as CarouselHeader
};
